import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { useWindowSize } from '@/hooks/useWindowSize';
import { MODAL_IDS } from '@/kit/Modal/keys';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const id = MODAL_IDS.account_delete_action_modal;

export const AccountDeleteActionModal = () => {
  const { modalIds } = useModal();
  const { closeModal } = useModal();
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('profile');

  if (!modalIds[id]) return null;

  const content = (
    <div className={classnames(s.modal)}>
      <div className="f-h2 f-500">
        {t('delete_acc_a_modal.action_required_before_deletion')}
      </div>
      <div className={classnames(s.content, 'f-body')}>
        {t('delete_acc_a_modal.conditions_to_delete_account')}
        <ul className={s.list}>
          <li>{t('delete_acc_a_modal.payouts_completed')}</li>
          <li>{t('delete_acc_a_modal.account_balance_zero')}</li>
        </ul>
        <div className={s.text_condition}>
          {t('delete_acc_a_modal.conditions_met_attempt_deletion')}
        </div>
      </div>
      <div className={s.footer}>
        <button
          type="button"
          className={classnames(r.black_large, s.btn_done)}
          onClick={() => closeModal(id)}
        >
          {t('delete_acc_a_modal.ok')}
        </button>
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
